import React from 'react';


const Slider = [
    {
        id: 1,
        name: "rifa",
        type: "web",
        message: "Loremjhbsjhbdjhbsjfhbjsdhvuydgivyugvuyg,Loremjhbsjhbdjhbsjfhbjsdhvuydgivyugvuyg,Loremjhbsjhbdjhbsjfhbjsdhvuydgivyugvuyg",
        img: "/images/cvl.jpg"
    },
    {
        id: 2,
        name: "alshifa",
        type: "software",
        message: "Loremjhbsjhbdjhbsjfhbjsdhvuydgivyugvuyg,Loremjhbsjhbdjhbsjfhbjsdhvuydgivyugvuyg",
        img: "../images/figur.jpg"
    },
    {
        id: 3,
        name: "ilma",
        type: "website",
        message: "Loremjhbsjhbdjhbsjfhbjsdhvuydgivyugvuyg",
        img: "../images/bridal.jpg"
    }
]


export default Slider









